views =
  'session-countdown'                 : require('./session-countdown.html.slim')
  'errors/401'                        : require('./errors/401.html.slim')
  'errors/403'                        : require('./errors/403.html.slim')
  'errors/404'                        : require('./errors/404.html.slim')
  'shared/login-form'                 : require('./shared/login-form.html.slim')
  'shared/login-form-staff'           : require('./shared/login-form-staff.html.slim')
  'shared/signup-form'                : require('./shared/signup-form.html.slim')
  'shared/client-search'              : require('./shared/client-search.html.slim')
  'shared/two-factor-form'            : require('./shared/two-factor-form.html.slim')
  'password'                          : require('./password.html.slim')
  'financial-plans/index'             : require('./financial-plans/index.html.slim')
  'financial-plans/v2'                : require('./financial-plans/v2.html.slim')
  'financial-plans/request-review'    : require('./financial-plans/request-review.html.slim')
  'financial-plans/chart-savings'     : require('./financial-plans/chart-savings.html.slim')
  'financial-plans/projected-savings' : require('./financial-plans/projected-savings.html.slim')
  'financial-plans/budget-items'      : require('./financial-plans/budget-items.html.slim')
  'financial-plans/timeline'          : require('./financial-plans/timeline.html.slim')
  'financial-plans/benefits'          : require('./financial-plans/benefits.html.slim')
  'financial-plans/start'             : require('./financial-plans/start.html.slim')
  'dashboard'                         : require('./dashboard.html.slim')
  'dashboard/user'                    : require('./dashboard/user.html.slim')
  'dashboard/staff'                   : require('./dashboard/staff.html.slim')
  'profile/index'                     : require('./profile/index.html.slim')
  'profile/basics'                    : require('./profile/basics.html.slim')
  'profile/identification'            : require('./profile/identification.html.slim')
  'profile/bankinfo'                  : require('./profile/bankinfo.html.slim')
  'profile/statement'                 : require('./profile/statement.html.slim')
  'profile/marital-status'            : require('./profile/marital-status.html.slim')
  'profile/dependents'                : require('./profile/dependents.html.slim')
  'profile/subscriptions'             : require('./profile/subscriptions.html.slim')
  'profile/security'                  : require('./profile/security.html.slim')
  'planning/index'                    : require('./planning/index.html.slim')
  'accounts/transactions'             : require('./accounts/transactions.html.slim')
  'clients'                           : require('./clients.html.slim')
  'tools/home-buying'                 : require('./tools/home-buying.nghtml')
  'tools/tfsa-vs-rrsp'                : require('./tools/tfsa-vs-rrsp.nghtml')
  'tools/canadian-tax-calculator'     : require('./tools/canadian-tax-calculator.nghtml')
  'tools/savings-plan'                : require('./tools/savings-plan.nghtml')
  'admin/demo/index'                  : require('./admin/demo/index.html.slim')
  'data-imports/list'                 : require('./data-imports/list.html.slim')
  'data-imports/show'                 : require('./data-imports/show.html.slim')

angular.module('wbViews', ['ngRoute']).run ['$rootScope', '$window', ($rootScope, $window) ->
  $rootScope.view = (path) -> views[path]

  $rootScope.setErrorTemplateUrl = (error) ->
    $rootScope.errorTemplateUrl = views['errors/' + error]

  $rootScope.$on '$routeChangeStart', (e, route) ->
    $rootScope.errorTemplateUrl = null
    route.templateUrl = views[route.view] if route.view?
    $rootScope.bannerUrl = views[route.bannerView]

  errorTitles = {
    403: "Access Denied",
    404: "There's nothing here"
  }

  $rootScope.$on '$routeChangeError', (e, c, p, error) ->
    $rootScope.setErrorTemplateUrl(error)
    title = errorTitles[error]
    $window.document.title = "#{$window.process.env.WHITELABEL_FULL_NAME} - #{title}"

  $rootScope.$on 'resourceException', (event, response) ->
    return unless _(errorTitles).keys().includes(response.status.toString())
    $rootScope.setErrorTemplateUrl(response.status)
    title = errorTitles[response.status]
    $window.document.title = "#{$window.process.env.WHITELABEL_FULL_NAME} - #{title}"
]
